import { selectorFamily } from "recoil";
import APIService from "../../APIService";
import { Apis } from "../../app.constants";
import { RecoilAtomKey } from "../../recoilConstantKey";
import { entityFormsStateAtomFamily, entityTableStateAtom } from "./entity.ts";

export const generateFilterKey = (filters) => {
  return Object.keys(filters)
    .sort()
    .map((key) => `${key}=${filters[key] || ''}`)
    .join("&");
};

export const fetchEntityFormListSelector = selectorFamily({
  key: "fetchEntityFormListSelector",
  get:(dropdownKey: string) => async ({ get }) => {
    const state = get(entityFormsStateAtomFamily(dropdownKey))
    // const state = get(entityTableStateAtom);
    const filterKey = generateFilterKey(state.filters);

    if (state.cache[filterKey]) {

      return {
        data: state.cache[filterKey],
        totalCount: state.totalCountCache[filterKey],
        fromCache: true,
      };
    }

    try {
        let url = `${Apis.entityManagement}form/list?next_page=${state.filters.page}&search=${state.filters.search}&entity_form_id=${state.filters?.entityFormId || ''}&limit=${state.filters.limit || 20}&organisation_id=${state?.filters?.organisation_id ?? ''}`;
        if (state.filters?.parentEntityFormId) {
          url += `&parent_id=${state.filters.parentEntityFormId}`;
        }
        const response = await APIService.get(url);
      return {
        data: response?.data?.items || [],
        totalCount: response?.data?.total_count || 0,
        fromCache: false,
      };
    } catch (error) {
      return { data: [], totalCount: 0, fromCache: false };
    }
  },
});